/* Little Star Co. — theme.js
   Handles: color/option swatches, quantity tiers with per-unit color pickers,
   per-variant image swap, AJAX add-to-cart, FAQ accordion. */
(function () {
  "use strict";

  /* ---------- Flying star: launches from the button that was clicked and
     arcs over to the cart icon, so adding to cart feels like an event.
     Uses a bright coral SVG star (not the emoji glyph) so the color is
     guaranteed to pop against any background, and runs slow enough to
     actually be seen. ---------- */
  var FLYING_STAR_SVG =
    '<svg viewBox="0 0 24 24" width="34" height="34"><path d="M12 1.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 17.27l-6.18 3.23L7 13.63l-5-4.87 6.91-1z" fill="#FF5A7A" stroke="#FFD84D" stroke-width="1.4" stroke-linejoin="round"/></svg>';

  function flyStarToCart(originEl, onDone) {
    var cartIcon = document.querySelector(".nav-cart");
    if (!originEl || !cartIcon) {
      if (onDone) onDone();
      return;
    }

    var startRect = originEl.getBoundingClientRect();
    var endRect = cartIcon.getBoundingClientRect();

    var star = document.createElement("div");
    star.className = "flying-star";
    star.innerHTML = FLYING_STAR_SVG;
    star.style.left = (startRect.left + startRect.width / 2 - 17) + "px";
    star.style.top = (startRect.top + startRect.height / 2 - 17) + "px";
    star.style.opacity = "1";
    star.style.transform = "translate(0, 0) scale(1) rotate(0deg)";
    document.body.appendChild(star);

    var deltaX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
    var deltaY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);
    var arcLift = -Math.max(160, Math.abs(deltaY) * 0.9);

    var animation = star.animate(
      [
        { transform: "translate(0, 0) scale(1) rotate(0deg)", opacity: 1, offset: 0 },
        { transform: "translate(" + (deltaX * 0.35) + "px, " + (deltaY * 0.35 + arcLift * 0.7) + "px) scale(1.5) rotate(140deg)", opacity: 1, offset: 0.4 },
        { transform: "translate(" + (deltaX * 0.75) + "px, " + (deltaY * 0.75 + arcLift * 0.2) + "px) scale(1.2) rotate(280deg)", opacity: 1, offset: 0.75 },
        { transform: "translate(" + deltaX + "px, " + deltaY + "px) scale(.35) rotate(400deg)", opacity: 0.3, offset: 1 },
      ],
      { duration: 1400, easing: "cubic-bezier(.2,.6,.35,1)" }
    );

    animation.onfinish = function () {
      star.remove();
      cartIcon.classList.add("pop");
      setTimeout(function () {
        cartIcon.classList.remove("pop");
      }, 400);
      if (onDone) onDone();
    };
  }

  /* ---------- Cart drawer: slides in from the right instead of navigating
     to a separate page, so adding to cart feels immediate. Content is the
     same "main-cart" section, fetched via Shopify's section-rendering
     endpoint and injected — the exact same markup as the full /cart page,
     so the qty/remove controls below work identically in both places. ---------- */
  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root.replace(/\/$/, "") + path;
  }

  function refreshCartDrawer() {
    var body = document.querySelector("[data-cart-drawer-body]");
    if (!body) return;
    fetch(cartRoute("/cart") + "?section_id=main-cart")
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        body.innerHTML = html;
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    var backdrop = document.querySelector("[data-cart-drawer-backdrop]");
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!backdrop || !drawer) return;
    refreshCartDrawer();
    backdrop.classList.add("open");
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-locked");
  }

  function closeCartDrawer() {
    var backdrop = document.querySelector("[data-cart-drawer-backdrop]");
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!backdrop || !drawer) return;
    backdrop.classList.remove("open");
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-locked");
  }

  function initCartDrawer() {
    var toggle = document.querySelector("[data-cart-toggle]");
    var backdrop = document.querySelector("[data-cart-drawer-backdrop]");
    var closeBtn = document.querySelector("[data-cart-drawer-close]");

    if (toggle) {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    }
    if (backdrop) backdrop.addEventListener("click", closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener("click", closeCartDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCartDrawer();
    });
    document.addEventListener("cart:updated", function () {
      var drawer = document.querySelector("[data-cart-drawer]");
      if (drawer && drawer.classList.contains("open")) refreshCartDrawer();
    });

    /* Delegated handlers so these work whether the cart-line markup lives on
       the full /cart page or was just injected into the drawer. */
    function updateLine(lineIndex, quantity) {
      fetch(cartRoute("/cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: lineIndex, quantity: quantity }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:updated"));
          if (!document.querySelector("[data-cart-drawer]").classList.contains("open")) {
            window.location.reload();
          }
        });
    }

    document.addEventListener("click", function (e) {
      var inc = e.target.closest("[data-qty-increase]");
      var dec = e.target.closest("[data-qty-decrease]");
      var rem = e.target.closest("[data-cart-remove]");
      if (inc) {
        var incInput = document.querySelector('[data-qty-input][data-line-index="' + inc.dataset.lineIndex + '"]');
        updateLine(inc.dataset.lineIndex, parseInt(incInput.value, 10) + 1);
      } else if (dec) {
        var decInput = document.querySelector('[data-qty-input][data-line-index="' + dec.dataset.lineIndex + '"]');
        updateLine(dec.dataset.lineIndex, Math.max(0, parseInt(decInput.value, 10) - 1));
      } else if (rem) {
        updateLine(rem.dataset.lineIndex, 0);
      }
    });
    document.addEventListener("change", function (e) {
      var input = e.target.closest("[data-qty-input]");
      if (input) updateLine(input.dataset.lineIndex, Math.max(0, parseInt(input.value, 10) || 0));
    });
  }

  /* ---------- Cart toast ---------- */
  function showToast(msg) {
    var toast = document.querySelector(".cart-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "cart-toast";
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    requestAnimationFrame(function () {
      toast.classList.add("show");
    });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      toast.classList.remove("show");
    }, 2200);
  }

  /* ---------- Sparkle / star-field background ---------- */
  function initStarField() {
    var field = document.getElementById("starField");
    if (!field) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var STAR_SVG =
      '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 0l2.6 8.4L23 11l-8.4 2.6L12 22l-2.6-8.4L1 11l8.4-2.6z"/></svg>';

    var count = window.innerWidth < 700 ? 14 : 26;
    var frag = document.createDocumentFragment();

    for (var i = 0; i < count; i++) {
      var star = document.createElement("div");
      star.className = "sparkle";
      star.innerHTML = STAR_SVG;

      var size = 8 + Math.random() * 16; // 8px–24px
      var left = Math.random() * 100; // vw — each star's horizontal lane
      var duration = 10 + Math.random() * 14; // 10s–24s to float across the screen
      var delay = Math.random() * -24; // negative delay = already mid-flight on load
      var maxOpacity = 0.18 + Math.random() * 0.3; // .18–.48
      var drift = (Math.random() * 120 - 60) + "px"; // sideways sway, +/-60px

      star.style.width = size + "px";
      star.style.height = size + "px";
      star.style.left = left + "vw";
      star.style.animationDuration = duration + "s";
      star.style.animationDelay = delay + "s";
      star.style.setProperty("--sparkle-max-opacity", maxOpacity);
      star.style.setProperty("--sparkle-drift", drift);
      if (Math.random() > 0.5) star.style.color = "var(--coral)";

      frag.appendChild(star);
    }

    field.appendChild(frag);
  }

  /* ---------- FAQ accordion ---------- */
  document.addEventListener("click", function (e) {
    var q = e.target.closest(".faq-q");
    if (q) {
      q.parentElement.classList.toggle("open");
    }
  });

  /* ---------- Buy box (per product form) ---------- */
  function initBuyBox(root) {
    var form = root.querySelector("form[data-product-form]");
    if (!form) return;

    var variants = [];
    try {
      variants = JSON.parse(root.getAttribute("data-variants") || "[]");
    } catch (err) {
      variants = [];
    }

    var colorOptionIndex = parseInt(root.getAttribute("data-color-option-index"), 10);
    if (isNaN(colorOptionIndex)) colorOptionIndex = -1;

    var colorValues = [];
    try {
      colorValues = JSON.parse(root.getAttribute("data-color-values") || "[]");
    } catch (err) {
      colorValues = [];
    }

    var variantImages = [];
    try {
      variantImages = JSON.parse(root.getAttribute("data-variant-images") || "[]");
    } catch (err) {
      variantImages = [];
    }

    var offerSection = root.closest(".offer");
    var productImg = offerSection ? offerSection.querySelector("[data-product-image]") : null;
    var thumbs = offerSection ? offerSection.querySelectorAll("[data-offer-thumb]") : [];
    var prevArrow = offerSection ? offerSection.querySelector("[data-offer-prev]") : null;
    var nextArrow = offerSection ? offerSection.querySelector("[data-offer-next]") : null;

    function imageFor(variantId) {
      var entry = variantImages.find(function (v) {
        return v.id === variantId;
      });
      return entry ? entry.image : null;
    }

    function setActiveThumbBySrc(src) {
      if (!thumbs.length) return;
      thumbs.forEach(function (t) {
        t.classList.toggle("active", t.getAttribute("data-full-src") === src);
      });
    }

    function showImage(src) {
      if (!productImg || !src) return;
      productImg.src = src;
      setActiveThumbBySrc(src);
    }

    function updateProductImage(variantId) {
      var src = imageFor(variantId);
      if (src) showImage(src);
    }

    /* Gallery: click a thumbnail, or use the prev/next arrows. */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        showImage(thumb.getAttribute("data-full-src"));
      });
    });

    function stepGallery(delta) {
      if (!thumbs.length) return;
      var thumbsArr = Array.prototype.slice.call(thumbs);
      var activeIndex = thumbsArr.findIndex(function (t) {
        return t.classList.contains("active");
      });
      if (activeIndex < 0) activeIndex = 0;
      var nextIndex = (activeIndex + delta + thumbsArr.length) % thumbsArr.length;
      showImage(thumbsArr[nextIndex].getAttribute("data-full-src"));
    }

    if (prevArrow) prevArrow.addEventListener("click", function () { stepGallery(-1); });
    if (nextArrow) nextArrow.addEventListener("click", function () { stepGallery(1); });

    function variantForColor(value) {
      if (colorOptionIndex < 0) return null;
      return variants.find(function (v) {
        return v.options[colorOptionIndex] === value;
      });
    }

    var dotOptionInputs = root.querySelectorAll(".option-block [data-option-index]");
    var tierEls = root.querySelectorAll(".tier[data-tier]");
    var tierToggles = root.querySelectorAll("[data-tier-toggle]");
    var priceNowEl = root.querySelector("#priceNow-" + root.dataset.sectionId);
    var priceWasEl = root.querySelector("#priceWas-" + root.dataset.sectionId);
    var addBtn = root.querySelector("[data-add-to-cart]");
    var variantIdInput = root.querySelector("[data-variant-id]");
    var qtyInput = root.querySelector("[data-quantity-input]");

    var mainColorBlock = null;
    if (colorOptionIndex >= 0) {
      var firstColorInput = root.querySelector('.option-block [data-option-index="' + colorOptionIndex + '"]');
      if (firstColorInput) mainColorBlock = firstColorInput.closest(".option-block");
    }

    var hasAnyTierGrid = root.querySelector("[data-tier-unit-grid]") !== null;

    var selectedOptions = {};
    dotOptionInputs.forEach(function (input) {
      if (input.classList.contains("selected")) {
        var idx = input.getAttribute("data-option-index");
        selectedOptions[idx] = input.getAttribute("data-value");
      }
    });

    var selectedTier = root.querySelector(".tier.selected") || tierEls[0];
    var quantity = selectedTier ? parseInt(selectedTier.getAttribute("data-qty"), 10) || 1 : 1;
    var discountPct = selectedTier ? parseFloat(selectedTier.getAttribute("data-discount")) || 0 : 0;

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (idx) {
          return v.options[idx] === selectedOptions[idx];
        });
      });
    }

    function formatMoney(cents) {
      return "$" + (cents / 100).toFixed(2);
    }

    /* Build the 2-column color grid (thumbnail + dropdown per unit) inside a tier. */
    function buildTierGrid(tier) {
      var wrap = tier.querySelector("[data-tier-unit-wrap]");
      var grid = tier.querySelector("[data-tier-unit-grid]");
      if (!wrap || !grid || grid.dataset.built) return;
      grid.dataset.built = "1";

      var qty = parseInt(wrap.getAttribute("data-tier-qty"), 10) || 1;
      var defaultColor = selectedOptions[colorOptionIndex] || colorValues[0];

      for (var i = 0; i < qty; i++) {
        var cell = document.createElement("div");
        cell.className = "unit-cell";

        var thumbWrap = document.createElement("div");
        thumbWrap.className = "unit-thumb-wrap";

        var thumb = document.createElement("img");
        thumb.className = "unit-thumb";
        thumb.alt = "";
        var defaultVariant = variantForColor(defaultColor);
        if (defaultVariant) {
          var src = imageFor(defaultVariant.id);
          if (src) thumb.src = src;
        }

        var zoomBtn = document.createElement("button");
        zoomBtn.type = "button";
        zoomBtn.className = "unit-thumb-zoom";
        zoomBtn.setAttribute("aria-label", "Click to zoom this color");
        zoomBtn.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/><path d="M21 21l-4.3-4.3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        zoomBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var img = this.previousElementSibling;
          if (img) document.dispatchEvent(new CustomEvent("thumb:zoom", { detail: { src: img.src, alt: img.alt } }));
        });

        thumbWrap.appendChild(thumb);
        thumbWrap.appendChild(zoomBtn);

        var select = document.createElement("select");
        select.className = "unit-select";
        select.setAttribute("data-unit-select", "1");

        colorValues.forEach(function (value) {
          var opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;
          if (value === defaultColor) opt.selected = true;
          select.appendChild(opt);
        });

        select.addEventListener("change", function () {
          var v = variantForColor(this.value);
          if (!v) return;
          var img = this.parentElement.querySelector(".unit-thumb");
          var src = imageFor(v.id);
          if (img && src) img.src = src;
          updateProductImage(v.id);
        });

        cell.appendChild(thumbWrap);
        cell.appendChild(select);
        grid.appendChild(cell);
      }

      var firstVariant = variantForColor(defaultColor);
      if (firstVariant) updateProductImage(firstVariant.id);
    }

    function setActiveTier() {
      tierEls.forEach(function (tier) {
        var wrap = tier.querySelector("[data-tier-unit-wrap]");
        var isActive = tier.classList.contains("selected");
        if (wrap) {
          if (isActive) buildTierGrid(tier);
          wrap.style.display = isActive ? "" : "none";
        }
      });

      if (mainColorBlock && hasAnyTierGrid) {
        var activeHasGrid = selectedTierHasGrid();
        mainColorBlock.style.display = activeHasGrid ? "none" : "";
      }
    }

    function selectedTierHasGrid() {
      var tier = root.querySelector(".tier.selected");
      return !!(tier && tier.querySelector("[data-tier-unit-grid]"));
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (qtyInput) qtyInput.value = quantity;

      var unitPrice = variant.price;
      var totalPrice = Math.round(unitPrice * quantity * (1 - discountPct / 100));
      var compareTotal = (variant.compare_at_price || unitPrice) * quantity;

      if (priceNowEl) priceNowEl.textContent = formatMoney(totalPrice);
      if (priceWasEl) {
        if (compareTotal > totalPrice) {
          priceWasEl.style.display = "";
          priceWasEl.textContent = formatMoney(compareTotal);
        } else {
          priceWasEl.style.display = "none";
        }
      }
      if (addBtn) {
        var label = addBtn.getAttribute("data-label") || "Add to Cart";
        addBtn.textContent = label + " — " + formatMoney(totalPrice);
        addBtn.disabled = !variant.available;
        if (!variant.available) {
          addBtn.textContent = "Sold Out";
        }
      }

      Object.keys(selectedOptions).forEach(function (idx) {
        var labelTarget = root.querySelector('[data-selected-label="' + idx + '"]');
        if (labelTarget) labelTarget.textContent = selectedOptions[idx];
      });

      if (!selectedTierHasGrid()) updateProductImage(variant.id);
    }

    dotOptionInputs.forEach(function (input) {
      input.addEventListener("click", function () {
        var idx = input.getAttribute("data-option-index");
        var value = input.getAttribute("data-value");
        var group = root.querySelectorAll('[data-option-index="' + idx + '"]');
        group.forEach(function (g) {
          g.classList.remove("selected");
        });
        input.classList.add("selected");
        selectedOptions[idx] = value;
        updateUI();
      });
    });

    tierToggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var tier = toggle.closest(".tier");
        if (!tier) return;
        tierEls.forEach(function (t) {
          t.classList.remove("selected");
        });
        tier.classList.add("selected");
        quantity = parseInt(tier.getAttribute("data-qty"), 10) || 1;
        discountPct = parseFloat(tier.getAttribute("data-discount")) || 0;
        setActiveTier();
        updateUI();
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var items;
      var activeTier = root.querySelector(".tier.selected");
      var grid = activeTier ? activeTier.querySelector("[data-tier-unit-grid]") : null;

      if (grid) {
        var selects = grid.querySelectorAll("select[data-unit-select]");
        items = [];
        var allAvailable = true;
        selects.forEach(function (select) {
          var v = variantForColor(select.value);
          if (!v || !v.available) {
            allAvailable = false;
            return;
          }
          items.push({ id: v.id, quantity: 1 });
        });
        if (!allAvailable || items.length === 0) {
          showToast("One of the selected colors is sold out.");
          return;
        }
      } else {
        var variant = findVariant();
        if (!variant || !variant.available) return;
        items = [{ id: variant.id, quantity: quantity }];
      }

      var protectionCheckbox = form.querySelector("[data-shipping-protection]");
      if (protectionCheckbox && protectionCheckbox.checked) {
        var protectionVariantId = protectionCheckbox.getAttribute("data-variant-id");
        if (protectionVariantId) {
          items.push({ id: parseInt(protectionVariantId, 10), quantity: 1 });
        }
      }

      var discountCode = activeTier ? activeTier.getAttribute("data-discount-code") : "";

      addBtn.disabled = true;
      var originalLabel = addBtn.textContent;
      addBtn.textContent = "Adding…";

      fetch(
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + "cart/add.js"
          : "/cart/add.js",
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items }),
        }
      )
        .then(function (res) {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then(function () {
          /* Apply the real Shopify discount code tied to this tier (if any)
             so the savings shown on the page actually land in the cart and
             at checkout, instead of being a display-only number.
             cart/update.js's "discount" field both applies a new code AND
             replaces whatever code was active before — important, since
             switching from the 2-Wrap to the 4-Wrap tier across visits
             would otherwise leave the old (now-inapplicable) code stuck
             and silently drop the new one. Passing "" clears it cleanly
             when the 1-Wrap tier (no discount) is selected. */
          return fetch(cartRoute("/cart/update.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ discount: discountCode || "" }),
          }).catch(function () {});
        })
        .then(function () {
          showToast("✓ Added to cart!");
          document.dispatchEvent(new CustomEvent("cart:updated"));
          flyStarToCart(addBtn, function () {
            openCartDrawer();
          });
        })
        .catch(function () {
          showToast("Something went wrong. Please try again.");
        })
        .finally(function () {
          addBtn.disabled = false;
          updateUI();
        });
    });

    setActiveTier();
    updateUI();
  }

  /* ---------- Product photo zoom lightbox: click the magnifying-glass badge
     on a color-picker thumbnail to see that exact color's photo full-screen.
     Dispatched from buildTierGrid, since those thumbnails are created
     dynamically. ---------- */
  function initImageZoom() {
    var backdrop = document.querySelector("[data-zoom-backdrop]");
    var lightbox = document.querySelector("[data-zoom-lightbox]");
    var lightboxImg = document.querySelector("[data-zoom-img]");
    var closeBtn = document.querySelector("[data-zoom-close]");
    if (!backdrop || !lightbox || !lightboxImg) return;

    function openZoom(src, alt) {
      if (!src) return;
      lightboxImg.src = src;
      lightboxImg.alt = alt || "";
      backdrop.classList.add("open");
      lightbox.classList.add("open");
      lightbox.setAttribute("aria-hidden", "false");
      document.body.classList.add("cart-drawer-locked");
    }

    function closeZoom() {
      backdrop.classList.remove("open");
      lightbox.classList.remove("open");
      lightbox.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cart-drawer-locked");
    }

    document.addEventListener("thumb:zoom", function (e) {
      openZoom(e.detail.src, e.detail.alt);
    });

    backdrop.addEventListener("click", closeZoom);
    if (closeBtn) closeBtn.addEventListener("click", closeZoom);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeZoom();
    });
  }

  function initBackToTop() {
    var btn = document.querySelector("[data-back-to-top]");
    if (!btn) return;
    function toggleVisibility() {
      if (window.scrollY > 500) {
        btn.classList.add("visible");
      } else {
        btn.classList.remove("visible");
      }
    }
    window.addEventListener("scroll", toggleVisibility, { passive: true });
    toggleVisibility();
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-buy-box]").forEach(initBuyBox);
    initStarField();
    initCartDrawer();
    initBackToTop();
    initImageZoom();
  });
})();
